module.exports = __webpack_public_path__ + "img/01.2e9c96da.jpg";